import React, { PureComponent } from 'react';
import { FiChevronLeft, FiChevronRight, FiChevronsLeft, FiChevronsRight } from "react-icons/fi";
import Calendar from 'react-calendar';
import { CSSTransition } from 'react-transition-group';
import moment from 'moment';
import { RadioGroup, RadioButton } from 'react-radio-buttons';
import '../../style/calendar.scss';

class DateRangePicker extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showCalendarStartDate: false,
            showCalendarEndDate: false,
            selectedperiod: "Today",
            periodintervals: ["Today", "Yesterday", "This Week", "Last Week", "This Month", "Last Month"],
        };
    }

    componentDidMount() {
        document.addEventListener("keydown", this.escFunctionForm, false);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.escFunctionForm, false);
    }

    escFunctionForm = (event) => {
        if (event.keyCode === 27) {
            this.setState({
                showCalendarStartDate: false,
                showCalendarEndDate: false
            });
        }
    }

    showStartDateCal = () => this.setState({ showCalendarStartDate: !this.state.showCalendarStartDate });
    showEndDateCal = () => this.setState({ showCalendarEndDate: !this.state.showCalendarEndDate });

    onClickStartDay = (date) => {
        const formattedDate = moment(date).format('YYYY-MM-DD');
        this.props.onStartDateChange(formattedDate);
        this.setState({ showCalendarStartDate: false });
    }

    onClickEndDay = (date) => {
        const formattedDate = moment(date).format('YYYY-MM-DD');
        this.props.onEndDateChange(formattedDate);
        this.setState({ showCalendarEndDate: false });
    }

    setDate = (date) => {
        if (!date) return new Date();
        let newDate = date.split('-');
        return new Date(newDate[0], newDate[1] - 1, newDate[2]);
    }

    onLeftArrowCalendar = (olddate, whichdate) => {
        let changeddate = moment(olddate, "YYYY-MM-DD").subtract(1, "days").format("YYYY-MM-DD")
        if (whichdate === "start") {
            this.props.onStartDateChange(changeddate);
        } else {
            this.props.onEndDateChange(changeddate);
        }
    }

    onRightArrowCalendar = (olddate, whichdate) => {
        let changeddate = moment(olddate, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD")
        if (whichdate === "start") {
            this.props.onStartDateChange(changeddate);
        } else {
            this.props.onEndDateChange(changeddate);
        }
    }

    onRightDoubleArrow = (olddate, whichdate) => {
        let changeddate = moment(olddate, "YYYY-MM-DD").add(1, "month").format("YYYY-MM-DD")
        if (whichdate === "start") {
            this.props.onStartDateChange(changeddate);
        } else {
            this.props.onEndDateChange(changeddate);
        }
    }

    onLeftDoubleArrow = (olddate, whichdate) => {
        let changeddate = moment(olddate, "YYYY-MM-DD").subtract(1, "month").format("YYYY-MM-DD")
        if (whichdate === "start") {
            this.props.onStartDateChange(changeddate);
        } else {
            this.props.onEndDateChange(changeddate);
        }
    }

    onSelectInterval = (event) => {
        this.setState({
            selectedperiod: event
        });
        if (event === "Today") {
            this.props.onStartDateChange(moment().format("YYYY-MM-DD"));
            this.props.onEndDateChange(moment().format("YYYY-MM-DD"));
        }
        else if (event === "Yesterday") {
            this.props.onStartDateChange(moment().subtract(1, "days").format("YYYY-MM-DD"));
            this.props.onEndDateChange(moment().subtract(1, "days").format("YYYY-MM-DD"));
        }
        else if (event === "This Week") {
            this.props.onStartDateChange(moment().startOf('week').add(1, "days").format("YYYY-MM-DD"));
            this.props.onEndDateChange(moment().endOf('week').add(1, "days").format("YYYY-MM-DD"));
        }
        else if (event === "Last Week") {
            this.props.onStartDateChange(moment().startOf('week').subtract(6, "days").format("YYYY-MM-DD"));
            this.props.onEndDateChange(moment().endOf('week').subtract(6, "days").format("YYYY-MM-DD"));
        }
        else if (event === "This Month") {
            this.props.onStartDateChange(moment().startOf('month').format("YYYY-MM-DD"));
            this.props.onEndDateChange(moment().endOf('month').format("YYYY-MM-DD"));
        }
        else if (event === "Last Month") {
            this.props.onStartDateChange(moment().subtract(1, "month").startOf('month').format("YYYY-MM-DD"));
            this.props.onEndDateChange(moment().subtract(1, "month").endOf('month').format("YYYY-MM-DD"));
        }
    }

    render() {
        const { startdate, enddate } = this.props;
        return (
            <div>
                <CSSTransition
                    in={this.state.showCalendarStartDate}
                    appear={true}
                    timeout={300}
                    classNames="fade"
                    unmountOnExit
                >
                    <div className="StartCalendar" onClick={(e) => {
                        if (e.target.className.includes("StartCalendar"))
                            this.setState({ showCalendarStartDate: false })
                        else if (e.target.className.includes("react-calendar__tile"))
                            this.setState({ showCalendarStartDate: false })
                    }}>
                        <Calendar
                            className="calendar"
                            value={this.setDate(startdate)}
                            onClickDay={this.onClickStartDay}
                        />
                    </div>
                </CSSTransition>
                <CSSTransition
                    in={this.state.showCalendarEndDate}
                    appear={true}
                    timeout={300}
                    classNames="fade"
                    unmountOnExit
                >
                    <div className="StartCalendar" onClick={(e) => {
                        if (e.target.className.includes("StartCalendar"))
                            this.setState({ showCalendarEndDate: false })
                        else if (e.target.className.includes("react-calendar__tile"))
                            this.setState({ showCalendarEndDate: false })
                    }}>
                        <Calendar
                            className="calendarEnd"
                            value={this.setDate(enddate)}
                            onClickDay={this.onClickEndDay}
                        />
                    </div>
                </CSSTransition>

                <div className="DateOptions">
                    <div className="StartDate">
                        <div className="startDateOptions">
                            <div className="DateLabels">From:</div>
                            <button type="button" onClick={() => this.onLeftDoubleArrow(startdate, "start")}><FiChevronsLeft /></button>
                            <button type="button" onClick={() => this.onLeftArrowCalendar(startdate, "start")}><FiChevronLeft /></button>
                            <h4 onClick={this.showStartDateCal}> {startdate} </h4>
                            <button type="button" onClick={() => this.onRightArrowCalendar(startdate, "start")}><FiChevronRight /></button>
                            <button type="button" onClick={() => this.onRightDoubleArrow(startdate, "start")}><FiChevronsRight /></button>
                        </div>
                    </div>
                    <div className="StartDate">
                        <div className="startDateOptions">
                            <div className="DateLabels">To:</div>
                            <button type="button" onClick={() => this.onLeftDoubleArrow(enddate, "end")}><FiChevronsLeft /></button>
                            <button type="button" onClick={() => this.onLeftArrowCalendar(enddate, "end")}><FiChevronLeft /></button>
                            <h4 onClick={this.showEndDateCal}> {enddate} </h4>
                            <button type="button" onClick={() => this.onRightArrowCalendar(enddate, "end")}><FiChevronRight /></button>
                            <button type="button" onClick={() => this.onRightDoubleArrow(enddate, "end")}><FiChevronsRight /></button>
                        </div>
                    </div>
                </div>
                <div className="IntervalOptions">
                    <div className="userTypeOptions">
                        <RadioGroup value={this.state.selectedperiod} onChange={this.onSelectInterval} horizontal>
                            {
                                this.state.periodintervals.map(option => {
                                    return (
                                        <RadioButton value={option} pointColor="#00dd21">
                                            {option}
                                        </RadioButton>
                                    )
                                })
                            }
                        </RadioGroup>
                    </div>
                </div>
            </div>
        );
    }
}

export default DateRangePicker;